import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';
import { useService } from 'shared/providers';
import { DownloadPdfProps } from 'shared/services/event-export-service';

export function usePdfExport<T>() {
  const { eventExportService } = useService();
  const { enqueueSnackbar } = useSnackbar();
  const mutation = useMutation<void, Error, DownloadPdfProps<T>>(
    request => eventExportService.downloadPdf(request), {
    onSuccess: () => {
      enqueueSnackbar('PDF was exported', { variant: 'success' });
    },
    onError: () => {
      enqueueSnackbar('PDF was not exported', { variant: 'error' });
    },
  });

  return mutation;
}
